export default "__VITE_ASSET__Du9921u8__"